<template>
  <q-form ref="form" class="full-width q-px-md">
    <div class="row">
      <div class="col-12">
        <q-tabs v-model="tab">
          <q-tab name="general" label="General" />
          <q-tab name="contacts" label="Contacts" />
        </q-tabs>
      </div>
    </div>
    <div class="row" v-if="tab == 'general'">
      <div class="col-12">
        <h6 class="q-my-none q-mt-xs">General</h6>
      </div>

      <!-- <div class="col-12 col-md-6 q-pa-xs">
        <q-input
          v-model="formData.contact"
          label="Contact"
          v-bind="siteCFG.fields.general"
        >
          <template v-slot:prepend>
            <q-icon name="mdi-account" />
          </template>
        </q-input>
      </div>
      <div class="col-12 col-md-6 q-pa-xs">
        <q-input
          label="Email"
          v-model="formData.email"
          v-bind="siteCFG.fields.general"
        >
          <template v-slot:prepend>
            <q-icon name="mdi-email" />
          </template>
        </q-input>
      </div>
      <div class="col-12 col-md-6 q-pa-xs">
        <q-input
          v-model="formData.phone"
          label="Phone"
          v-bind="siteCFG.fields.general"
        >
          <template v-slot:prepend>
            <q-icon name="mdi-phone" />
          </template>
        </q-input>
      </div> -->
      <div class="col-12 col-md-6 q-pa-xs">
        <q-input
          v-model="formData.name"
          label="Name"
          readonly
          v-bind="siteCFG.fields.general"
        >
        </q-input>
      </div>
      <div class="col-12 col-md-6 q-pa-xs">
        <q-input
          v-model="formData.key"
          label="Key"
          readonly
          v-bind="siteCFG.fields.general"
        >
        </q-input>
      </div>
      <div class="col-12 col-md-6 q-pa-xs">
        <q-input
          v-model="formData.accountsEmail"
          label="accountsEmail"
          v-bind="siteCFG.fields.general"
        >
          <template v-slot:prepend>
            <q-icon name="mdi-email" />
          </template>
        </q-input>
      </div>
      <div class="col-12 col-md-6 q-pa-xs">
        <q-input
          v-model="formData.entryFormLink"
          label="Entry Form Link"
          v-bind="siteCFG.fields.general"
        >
          <template v-slot:prepend>
            <q-icon name="mdi-earth" />
          </template>
        </q-input>
      </div>
    </div>
    <div class="row" v-if="tab == 'contacts'">
      <div class="col-12 col-md-6">
        <div class="row">
          <div class="col-12">
            <h6 class="q-my-none q-mt-xs">Contacts</h6>
          </div>
          <div class="col-12 col-md-6 q-pa-xs">
            <q-input
              v-model="formData.contactName"
              label="Contact"
              v-bind="siteCFG.fields.general"
            >
              <template v-slot:prepend>
                <q-icon name="mdi-account" />
              </template>
            </q-input>
          </div>
          <div class="col-12 col-md-6 q-pa-xs">
            <q-input
              label="Email"
              v-model="formData.contactEmail"
              v-bind="siteCFG.fields.general"
            >
              <template v-slot:prepend>
                <q-icon name="mdi-email" />
              </template>
            </q-input>
          </div>
          <div class="col-10 col-md-5 q-pa-xs">
            <q-input
              v-model="formData.contactPhone"
              label="Phone"
              v-bind="siteCFG.fields.general"
            >
              <template v-slot:prepend>
                <q-icon name="mdi-phone" />
              </template>
            </q-input>
          </div>
          <div class="col-2 col-md-1 q-pa-xs">
            <q-input
              v-model="formData.contactPhoneExt"
              label="Ext"
              v-bind="siteCFG.fields.general"
            >
            </q-input>
          </div>
          <div class="col-12 col-md-6 q-pa-xs">
            <q-input
              v-model="formData.contactMobile"
              label="Mobile"
              v-bind="siteCFG.fields.general"
            >
              <template v-slot:prepend>
                <q-icon name="mdi-cellphone" />
              </template>
            </q-input>
          </div>
        </div>
      </div>
    </div>
  </q-form>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    components: {},
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        siteCFG: "settings/siteCFG",
      }),
    },
    props: {
      data: {
        type: Object,
        default: null,
      },
    },
    watch: {
      data: function () {
        this.init();
      },
    },
    data: () => ({
      // Extra Data
      formData: {},
      tab: "general",

      impersonatingUser: false,
    }),
    beforeCreate() {},
    mounted() {
      setTimeout(() => {
        this.init();
      }, 100);
    },
    methods: {
      init() {
        if (this.data != null) {
          this.formData = JSON.parse(JSON.stringify(this.data));
        } else {
          this.formData = {};
        }
      },
      create() {
        this.$emit("loadingStateChanged", true);
        this.$refs.form.validate().then((result) => {
          if (result) {
            this.$store
              .dispatch("associations/new", this.formData)
              .then((result) => {
                this.$emit("loadingStateChanged", false);
                if (result.Result == "Success") {
                  this.$emit("close", true);
                  this.formData = {};
                  this.$q.notify({
                    position: "top-right",
                    type: "positive",
                    message: result.Response.Message,
                  });
                } else {
                  this.$q.notify({
                    position: "top-right",
                    type: "negative",
                    message: result.Response.Message,
                  });
                }
              });
          } else {
            this.$emit("loadingStateChanged", false);
          }
        });
      },
      save() {
        this.$emit("loadingStateChanged", true);

        this.$store
          .dispatch("associations/save", this.formData)
          .then((result) => {
            this.$emit("loadingStateChanged", false);
            if (result.Result == "Success") {
              this.address = "";
              this.$emit("close", true);
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: "User has been saved",
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .formSubTitle {
    font-weight: bold;
  }
</style>
